import { useRouterState } from "@tanstack/react-router";

// ===========================================================================
// Qué rutas son del módulo de conciliación.
//
// Existe para que la barra superior pueda enseñar el periodo y el buscador
// SOLO cuando se está trabajando aquí dentro. Hoy, en una app que es solo este
// módulo, la condición se cumple casi siempre; el día que esto viva dentro del
// ERP —donde la barra la comparten veinte módulos— es lo que evita que el
// periodo de conciliación aparezca mientras alguien mira una planilla.
//
// Al mudarlo, esta lista pasa a tener el prefijo del módulo y no cambia nada
// más: `/conciliacion`, `/conciliacion/movimientos`…
// ===========================================================================

export const RUTAS_DEL_MODULO = [
  "/",
  "/movimientos",
  "/documentos",
  "/empresas",
] as const;

export function esRutaDelModulo(ruta: string): boolean {
  return RUTAS_DEL_MODULO.some((r) =>
    r === "/" ? ruta === "/" : ruta.startsWith(r),
  );
}

/** `true` mientras se navegue dentro del módulo de conciliación. */
export function useEstaEnElModulo(): boolean {
  return useRouterState({
    select: (s) => esRutaDelModulo(s.location.pathname),
  });
}
